<div class="select" (click)="toggleDropdown()">
	<div class="selected">
		@if (selectedOption() === "margin") {
			<div class="content-container">
				<img class="custom-icon" alt="" ngSrc="assets/images/mt/mt-arrow.png" height="48" width="48" />
				<span> {{ "up_to" | translate: [maximumMarginLevel()] }}</span>
				<span class="tag">{{ "margin_trading" | translate }}</span>
			</div>
			<bp-icon theme="regular" icon="chevron-down" size="16" />
		} @else {
			<div class="content-container">
				<img class="custom-icon" alt="" ngSrc="assets/images/mt/leverage-icon.png" height="48" width="48" />
				<span> {{ "up_to" | translate: [2] }}</span>
				<span class="tag">{{ "leveraged_tokens" | translate }}</span>
			</div>
			<bp-icon theme="regular" icon="chevron-down" size="16" />
		}
	</div>

	@if (isOpen) {
		<ul class="dropdown">
			<li
				(click)="select(switchType.MARGIN); $event.stopPropagation()"
				[class.selected]="selectedOption() === 'margin'">
				<div class="content-container">
					<img class="custom-icon" alt="" src="assets/images/mt/mt-arrow.png" height="48" width="48" />
					<span> {{ "up_to" | translate: [maximumMarginLevel()] }}</span>
					<span class="tag">{{ "margin_trading" | translate }}</span>
				</div>
				@if (selectedOption() === "margin") {
					<bp-icon theme="regular" icon="checkmark" size="16" />
				}
			</li>
			<li
				(click)="select(switchType.LEVERAGE); $event.stopPropagation()"
				[class.selected]="selectedOption() === 'leverage'">
				<div class="content-container">
					<img class="custom-icon" alt="" src="assets/images/mt/leverage-icon.png" height="48" width="48" />
					<span>{{ "up_to" | translate: [2] }}</span>
					<span class="tag">{{ "leveraged_tokens" | translate }}</span>
				</div>
				@if (selectedOption() === "leverage") {
					<bp-icon theme="regular" icon="checkmark" size="16" />
				}
			</li>
		</ul>
	}
</div>
